import { render, staticRenderFns } from "./DupesAreaPagination.vue?vue&type=template&id=246b7d14"
import script from "./DupesAreaPagination.vue?vue&type=script&lang=js"
export * from "./DupesAreaPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports